import { Authenticator, AuthType, type HeaderMap } from '@snapchat/metrics-utils';
import { computeWebAttestation } from './computeWebAttestation';

export const webAttestationHeader = 'X-Snapchat-Web-Client-Auth';

export class WebAuthenticator extends Authenticator {
  async authRequest(
    authType: AuthType,
    payload: Uint8Array,
    headers: HeaderMap
  ): Promise<HeaderMap> {
    switch (authType) {
      case AuthType.None: {
        return headers;
      }
      case AuthType.WebAttestation: {
        const webAttestationHeaderBase64 = await computeWebAttestation(payload);
        return {
          ...headers,
          [webAttestationHeader]: webAttestationHeaderBase64,
        };
      }
      default: {
        throw new Error(`Unsupported auth type: ${authType}`);
      }
    }
  }
}
